<script setup lang="ts">
  import { useHero } from '@/composables/useHero';
  import type { HeroData } from '@/models/hero';
  import HeroCard from '@/components/hero/HeroCard.vue';
  import type { PropType } from 'vue';

  const props = defineProps({
    heroData: {
      type: Object as PropType<HeroData>,
      required: true
    }
  });

  const { animationRef, animationLoaded, mappedMessages } = useHero(props.heroData);
</script>

<template>
  <section>
    <div class="container">
      <div class="hero-section">
        <div class="hero-section__left">
          <h1 v-html="heroData.heading" />
          <p>
            {{ heroData.description }}
          </p>
        </div>
        <div
          class="hero-section__right"
          :class="{ loaded: animationLoaded }">
          <div
            ref="animationRef"
            class="hero-animation" />
          <HeroCard
            v-for="(message, index) in mappedMessages"
            :key="index"
            :message="message" />
        </div>
      </div>
    </div>
  </section>
</template>
